// ListSelect for locations. Identical interaction, different payload underneath - a location is a
// record with a country and an address, not a code and a label.

import { useState } from 'react';

import Icon from '../../ui/Icon.jsx';
import AddLocationDialog from './AddLocationDialog.jsx';

export default function LocationSelect({ label, locations, value, onChange, error, onAdded }) {
  const [adding, setAdding] = useState(false);

  return (
    <label className="field list-select">
      <span className="field-label">{label}</span>
      <span className="field-control">
        <select value={value ?? ''} onChange={(event) => onChange(event.target.value)}>
          <option value="">—</option>
          {locations.map((location) => (
            <option key={location.code} value={location.code}>{location.label}</option>
          ))}
        </select>
        <button type="button" className="icon-button quiet" onClick={() => setAdding(true)}
                aria-label="Add new location" title="Add new location">
          <Icon name="plus" />
        </button>
      </span>
      {error && <span className="field-error">{error}</span>}

      {adding && (
        <AddLocationDialog
          onClose={() => setAdding(false)}
          onAdded={(location) => {
            setAdding(false);
            onAdded();
            onChange(location.code);
          }}
        />
      )}
    </label>
  );
}
